import { useMemo, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import DashboarLinksSection, { DashboardLinksSectionProps } from "@components/content/DashboardLinksSection";
import LoadingScreen from "@components/content/LoadingScreen";
import ConfirmModal from "@components/content/ConfirmModal";
import { showAlert } from "@utils/Alert";
import EstadoCuentaIcon from "@assets/icons-png/estado-cuenta.png";
import RepairIcon from "@assets/icons-png/repair-icon.png";
import { resetInventoryStocks } from "@/api/InventoryAdminApi";

const InventoryManagement = () => {
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toggleConfirm = () => setIsConfirmOpen((prev) => !prev);

  const runReset = async () => {
    setIsLoading(true);
    try {
      const { updatedCount } = await resetInventoryStocks();
      showAlert("success", `Inventario reiniciado. Productos actualizados: ${updatedCount}`);
    } catch (err) {
      const message = err instanceof Error ? err.message : "No fue posible reiniciar el inventario";
      showAlert("danger", message);
    } finally {
      setIsLoading(false);
    }
  };

  const groupLinks: DashboardLinksSectionProps[] = useMemo(() => {
    return [
      {
        title: "Administración de Inventarios",
        links: [
          {
            icon: EstadoCuentaIcon,
            iconAlt: "Icono Reiniciar Existencias de Inventarios",
            title: "Reiniciar Existencias de Inventarios",
            url: "#",
            onClick: () => setIsConfirmOpen(true),
          },
          {
            icon: RepairIcon,
            iconAlt: "Icono Verificar Cabys de Productos",
            title: "Verificar Cabys de Productos",
            url: "/user/products/inventory-management/verify-cabys",
          },
          {
            icon: RepairIcon,
            iconAlt: "Icono Verificar Cabys de Categorias",
            title: "Verificar Cabys de Categorias",
            url: "/user/products/inventory-management/verify-cabys-categories",
          }
        ]
      }
    ];
  }, []);

  return (
    <PageContainer title="Administración de Inventarios" backUrl="/user/products">
      {groupLinks.map((gl) => (
        <DashboarLinksSection key={gl.title} title={gl.title} links={gl.links} />
      ))}

      <ConfirmModal
        isOpen={isConfirmOpen}
        toggle={toggleConfirm}
        title="Reiniciar Inventario"
        primaryBtn="Reiniciar"
        primaryBtnColor="danger"
        secondaryBtn="Cancelar"
        secondaryBtnColor="secondary"
        onConfirm={async () => {
          setIsConfirmOpen(false);
          await runReset();
        }}
        onCancel={() => setIsConfirmOpen(false)}
      >
        Esta acción no es reversible. Todas las existencias se establecerán en 0. ¿Desea continuar?
      </ConfirmModal>

      <LoadingScreen isLoading={isLoading} />
    </PageContainer>
  );
};

export default InventoryManagement;

